export default __webpack_public_path__ + "34249f50c0b08d875e753245eafb7acb.png";